import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Boxes, LogOut, ShieldCheck } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const dashboardHref =
    user?.role === "student"
      ? "/app/student"
      : user?.role === "teacher"
      ? "/app/teacher"
      : user?.role === "admin"
      ? "/app/admin"
      : "/login";

  return (
    <header
      className="glass-header sticky top-0 z-40 border-b border-border/60"
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-2.5" data-testid="logo-link">
          <div className="flex h-9 w-9 items-center justify-center bg-foreground text-background">
            <Boxes className="h-5 w-5" strokeWidth={2.5} />
          </div>
          <div className="leading-none">
            <div className="font-display text-base font-extrabold tracking-tighter">
              GROWTHINK
            </div>
            <div className="mono text-[10px] uppercase tracking-widest text-muted-foreground">
              AI-CADEMY · v1
            </div>
          </div>
        </Link>

        <nav className="hidden items-center gap-7 md:flex">
          <Link
            to="/courses"
            className="mono text-xs uppercase tracking-wider text-foreground/80 hover:text-foreground"
            data-testid="nav-courses"
          >
            Courses
          </Link>
          <Link
            to="/verify"
            className="mono text-xs uppercase tracking-wider text-foreground/80 hover:text-foreground flex items-center gap-1.5"
            data-testid="nav-verify"
          >
            <ShieldCheck className="h-3.5 w-3.5" /> Verify
          </Link>
          <a
            href="#features"
            className="mono text-xs uppercase tracking-wider text-foreground/80 hover:text-foreground"
            data-testid="nav-features"
          >
            Features
          </a>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Button
                variant="outline"
                className="rounded-none border-foreground hard-shadow-sm"
                onClick={() => navigate(dashboardHref)}
                data-testid="header-dashboard-btn"
              >
                Dashboard
              </Button>
              <Button
                variant="ghost"
                className="rounded-none"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                data-testid="header-logout-btn"
              >
                <LogOut className="mr-2 h-4 w-4" /> Logout
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="ghost"
                className="rounded-none"
                onClick={() => navigate("/login")}
                data-testid="header-login-btn"
              >
                Sign in
              </Button>
              <Button
                className="rounded-none bg-foreground text-background hard-shadow hover-lift"
                onClick={() => navigate("/login")}
                data-testid="header-cta-btn"
              >
                Get started →
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
